import { lazy } from 'react'

const SkillsDecoder = lazy(async () => {
  const { SkillsDecoder: SkillsDecoderModule } = await import(
    /* webpackChunkName: "skills-decoder" */ './'
  )

  return {
    default: SkillsDecoderModule
  }
})
const routes = [
  {
    path: '/skills/decoder',
    name: 'Skills Decoder',
    authenticated: true,
    render(props) {
      return <SkillsDecoder {...props} />
    }
  }
]

export { routes }
